// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"514":"bb54470d","652":"35bf863c"}[chunkId] + ".chunk.js";
};